import { render, staticRenderFns } from "./IsogdDocInPointList.vue?vue&type=template&id=eb8acd1e&"
import script from "./IsogdDocInPointList.vue?vue&type=script&lang=js&"
export * from "./IsogdDocInPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports